/* eslint-disable class-methods-use-this */
/* globals duration, elasticEase, paper, imagesLoaded */

import { gsap } from 'gsap/all';
import { enableBodyScroll } from 'body-scroll-lock';

class ControlPoint {
    constructor(index, line, path, start, canMove, callBack) {
        this.shape = null;
        this.animation = null;
        this.connected = false;

        const pointShape = new paper.Path.Circle({
            center: [0, 0],
            radius: 0,
            fillColor: '#e91e63',
            strokeColor: '#ce1956',
            fillAlpha: 0,
        });

        const pointSymbol = new paper.Symbol(pointShape.rasterize());
        pointShape.remove();

        function randomIntFromInterval(min, max) { // min and max included
            return Math.floor(Math.random() * (max - min + 1) + min);
        }

        const rndInt = randomIntFromInterval(0, 300);

        if (canMove) {
            this.shape = pointSymbol.place(start);
            this.shape.parent = path.parent;
            this.animation = gsap.timeline();
            let completeCalled = false;
            const canvasElement = document.getElementById(`transition-canvas-${window.currentTransitionIndex}`);
            this.reverseAnimation = gsap.timeline({
                paused: true,
                onUpdate: () => {
                    if (this.reverseAnimation.progress() > 0.6 && !completeCalled && index === 3) {
                        completeCalled = true;
                        window.ColorBleedApp.router.pageTransitionComplete();

                        if (!window.ColorBleedApp.router.app.currentSlug === 'projects') {
                            enableBodyScroll(document.documentElement);
                        }
                    }
                },
                onComplete: () => {
                    callBack();
                    gsap.set(canvasElement, {
                        rotate: '0deg',
                        autoAlpha: 0,
                    });
                },
            });

            gsap.delayedCall(0, () => {
                // eslint-disable-next-line no-shadow
                const { start } = this;
                const shape = this.shape.position;
                const { point } = this.path.segments[this.index];

                this.animation.clear();
                gsap.set(`#transition-canvas-${window.currentTransitionIndex}`, {
                    autoAlpha: 1,
                });
                this.animation.to([point, shape], {
                    duration: 2,
                    x: start.x,
                    y: -15,
                    ease: elasticEase,
                    onUpdate: () => {
                        if (this.animation.progress() > 0.4) {
                            this.animation.pause();
                            this.animation.clear();
                            gsap.set(`#transition-canvas-${window.currentTransitionIndex}`, {
                                rotate: '180deg',
                            });

                            EventBus.$emit('transition-halfway');
                            this.reverseAnimation.to([point, shape], {
                                duration: 2,
                                x: start.x,
                                y: start.y,
                                ease: elasticEase,
                            }, rndInt / 1000);

                            imagesLoaded('.project__header', () => {
                                this.reverseAnimation.play();
                            });
                        }
                    },
                }, rndInt / 1000);
            });
        }

        this.index = index;
        this.line = line;
        this.start = start;
        this.path = path;
        this.snapping = false;
    }

    destroy() {
        // eslint-disable-next-line no-unused-expressions
        this.animation && this.animation.kill();

        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const prop in this) {
            this[prop] = null;
        }
    }

    refresh() {
        return true;
    }

    snapBack() {
        this.snapping = true;
        const { start } = this;
        const shape = this.shape.position;
        const { point } = this.path.segments[this.index];

        // this.animation.clear();
        EventBus.$emit('snapBack');
        this.animation.to([point, shape], {
            duration,
            x: start.x,
            y: start.y,
            ease: elasticEase,
            onComplete() {
                // this.snapping = false;
            },
        }, 0);

        gsap.delayedCall(1, () => {
            this.snapping = false;
        });
    }

    snapTrough() {
        const { start } = this;
        const shape = this.shape.position;
        const { point } = this.path.segments[this.index];

        this.animation.clear();
        this.animation.to([point, shape], {
            duration,
            x: start.x,
            y: 0,
            ease: elasticEase,
        }, 0);
    }
}

export default ControlPoint;
